import React, {useMemo} from 'react';
import type {SxProps} from '@mui/material';
import {Tooltip, useTheme} from '@mui/material';
import Chip from '@mui/material/Chip';
import {useLocalization} from 'localization';
import {Layout} from 'components';

type Props = {
  isMainForm: boolean;
  /** undefined if NORAF was not loaded/found */
  isMainFormInNoraf: boolean | undefined;
  sx?: SxProps;
};

export const NameVariantMainForm: React.FC<Props> = ({
  isMainForm,
  isMainFormInNoraf,
  sx,
}) => {
  const {t} = useLocalization();
  const {status} = useTheme();

  const {label, help} = useMemo(() => {
    return {
      label: isMainForm
        ? t('form.global.field.nameVariantMain.label')
        : isMainFormInNoraf
          ? t('form.global.field.nameVariantNoraf.label')
          : '',
      help:
        isMainForm && isMainFormInNoraf
          ? t('page.agents.nameVariants.ebbaAndNoraf')
          : isMainForm
            ? t('page.agents.nameVariants.onlyEbba')
            : isMainFormInNoraf
              ? t('page.agents.nameVariants.onlyNoraf')
              : '',
    };
  }, [isMainForm, isMainFormInNoraf, t]);

  return (
    <Layout hidden={!isMainForm && !isMainFormInNoraf} adjustCenter sx={sx}>
      <Tooltip title={help}>
        <Chip
          size="small"
          label={label}
          sx={{
            background: isMainForm
              ? isMainFormInNoraf === undefined
                ? '#FFEEB1' // was ColorPalette.spot.urgent
                : isMainFormInNoraf
                  ? '#F1FFC3' // was ColorPalette.spot.new40
                  : status.change
              : status.change,
          }}
        />
      </Tooltip>
    </Layout>
  );
};
